class SearchBar {
  constructor() {
    this.searchBarForm = document.querySelector('[data-search-bar]');
    this.searchBarInput = document.querySelector('[data-search-bar-input]');
    this.searchBarBtn = document.querySelector('[data-search-bar-button]');
    this.searchBarCloseBtn = document.querySelector('[data-search-bar-close]');

    if (
      !(
        this.searchBarForm &&
        this.searchBarInput &&
        this.searchBarBtn &&
        this.searchBarCloseBtn
      )
    ) {
      return;
    }

    this.SEARCH_PAGE_URL = this.searchBarForm.attributes['data-search-url'].value;

    this.searchBarForm.addEventListener('submit', this.onSearchSubmit.bind(this));
    this.searchBarBtn.addEventListener('click', this.showSearchBar.bind(this));
    this.searchBarCloseBtn.addEventListener('click', this.hideSearchBar.bind(this));
  }

  onSearchSubmit(e) {
    e.preventDefault();
    const url = this.SEARCH_PAGE_URL + '?search=' + this.searchBarInput.value;
    window.location = url;
  }

  showSearchBar() {
    if (this.searchBarForm.classList.contains('hidden')) {
      this.searchBarForm.classList.remove('hidden');
      this.searchBarBtn.classList.add('is-open');
      this.searchBarInput.focus();
    } else {
      this.searchBarForm.classList.add('hidden');
      this.searchBarBtn.classList.remove('is-open');
    }
  }

  hideSearchBar(e) {
    e.preventDefault();
    this.searchBarForm.classList.add('hidden');
    this.searchBarBtn.classList.remove('is-open');
  }
}

export default SearchBar;
